import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';

export class WFEReplaceInvoiceFileParametersDto {
    workflowId: number;
    workflowStatus: string; // NOTE: Required for most endpoints of workflow editor except for getting data entry editor
    communityId: number;
    payeeCode: string; // 	Either VendorCode, Owner - CustomerId, Community - IntacctCompanyId
    fileName: string; // 	NOTE: File type must be PDF
    fileBase64string: string; // Base64 string of newly uploaded invoice file

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    invoiceDate: Date;

    invoiceNumber: string;
}
